// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_order_search_uimfe_styles" + "." + "1cae3093" + ".chunk.css";
};